import {
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '@ops/shared-types';
import { OpsCreditCardCreateComponent } from '@ops/storybook';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ops-credit-card-create-modal',
  standalone: true,
  imports: [CommonModule, OpsCreditCardCreateComponent],
  template: `
    <div class="modal-overlay" *ngIf="isOpen" (click)="close()" (keydown.escape)="close()" tabindex="0">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <ops-credit-card-create
          (closeModal)="handleCloseModal($event)"
        ></ops-credit-card-create>
      </div>
    </div>
  `,
  styles: [`
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }
    
    .modal-content {
      background: white;
      border-radius: 8px;
      max-width: 90vw;
      max-height: 90vh;
      overflow: auto;
    }
  `]
})
export class CreditCardCreateModalComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Output() creditCardCreated = new EventEmitter<void>();
  
  isOpen = false;
  private element: HTMLElement;
  private subscriptions: Subscription[] = [];

  constructor(
    private el: ElementRef,
    private modalService: ModalService
  ) {
    this.element = this.el.nativeElement;
  }

  ngOnInit(): void {
    if (!this.id) {
      console.error('@Input id is mandatory');
      return;
    }
    
    this.element.style.display = 'none';
    document.body.appendChild(this.element);
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element?.remove();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  open(): void {
    this.isOpen = true;
    this.element.style.display = 'block';
    // Focus the modal overlay for keyboard navigation
    setTimeout(() => {
      const overlay = this.element.querySelector('.modal-overlay') as HTMLElement;
      if (overlay) {
        overlay.focus();
      }
    }, 100);
  }

  close(): void {
    this.isOpen = false;
    this.element.style.display = 'none';
  }

  handleCloseModal(result: boolean | null): void {
    this.close();
    // You can emit a result if needed
    if (result) {
      // Credit card was created successfully
      this.creditCardCreated.emit();
    }
  }
}
